type CookieOptions = {
  expires?: Date;
  domain?: string;
  sameSite?: 'strict' | 'lax' | 'none';
};

export const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
  if (!match) {
    return undefined;
  }
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

export const setCookie = (name: string, value: string, opts: CookieOptions = {}): void => {
  if (typeof document === 'undefined') {
    return;
  }
  let cookie = `${name}=${encodeURIComponent(value)}; Path=/; Secure`;
  if (opts.expires) cookie += `; Expires=${opts.expires.toUTCString()}`;
  if (opts.domain) cookie += `; Domain=${opts.domain}`;
  if (opts.sameSite) cookie += `; SameSite=${opts.sameSite}`;
  document.cookie = cookie;
};
